import { render, staticRenderFns } from "./PrivacyProtection.vue?vue&type=template&id=108cbdb4&scoped=true&"
import script from "./PrivacyProtection.vue?vue&type=script&lang=js&"
export * from "./PrivacyProtection.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyProtection.vue?vue&type=style&index=0&id=108cbdb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108cbdb4",
  null
  
)

export default component.exports